import { render } from "./CreateLecture.vue?vue&type=template&id=f08f4c10"
import script from "./CreateLecture.vue?vue&type=script&lang=js"
export * from "./CreateLecture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__